import { Link } from 'react-router-dom'
export default function NotFound() { return <section className="not-found"><span>404</span><h1>This page is still learning.</h1><p>The page you requested does not exist.</p><Link className="button" to="/">Return home</Link></section> }
